import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { type CommonAgreementConsentsProps } from "../../types/consentProps"
import { ElectricityAgreementConsents } from "../ElectricityAgreementConsents"
import { GasAgreementConsents } from "../GasAgreementConsents"

const graphQLFragments = {
    agreement: graphql(
        `
            fragment AgreementConsents_Agreement on AgreementType {
                supplyPoint {
                    marketName
                }
                ...ElectricityAgreementConsents_Agreement
                ...GasAgreementConsents_Agreement
            }
        `,
        [ElectricityAgreementConsents.fragments.agreement, GasAgreementConsents.fragments.agreement]
    ),
}

type AgreementConsentsProps = CommonAgreementConsentsProps & {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
    isEcoSessionActive?: boolean
    accountNumber?: string
}

export function AgreementConsents(props: AgreementConsentsProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    switch (agreement.supplyPoint?.marketName) {
        case "FRA_ELECTRICITY":
            return (
                <ElectricityAgreementConsents
                    {...props}
                    agreement={agreement}
                />
            )
        case "FRA_GAS":
            return (
                <GasAgreementConsents
                    {...props}
                    agreement={agreement}
                />
            )
        default:
            return null
    }
}

AgreementConsents.messages = [
    ...ElectricityAgreementConsents.messages,
    ...GasAgreementConsents.messages,
] as const

AgreementConsents.fragments = graphQLFragments
